import React, { useEffect, useState } from 'react';
import { SaveIcon } from 'lucide-react';
export function ContactForm({
  contact,
  onSave,
  onCancel,
  locale
}) {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
    role: 'Admin',
    isPrimary: false
  });
  useEffect(() => {
    if (contact) {
      setFormData({
        ...contact
      });
    } else {
      setFormData({
        id: '',
        name: '',
        email: '',
        phone: '',
        role: 'Admin',
        isPrimary: false
      });
    }
  }, [contact]);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="bg-white shadow sm:rounded-lg" data-id="element-14598">
      <div className="px-4 py-5 sm:p-6" data-id="element-14599">
        <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-14600">
          {contact ? 'Edit Contact' : 'Add Contact'}
        </h3>
        <form className="mt-5 space-y-6" onSubmit={handleSubmit} data-id="element-14601">
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-14602">
            <div className="sm:col-span-6" data-id="element-14603">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-14604">
                Name
              </label>
              <div className="mt-1" data-id="element-14605">
                <input type="text" name="name" id="name" value={formData.name} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-14606" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-14607">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-14608">
                Email
              </label>
              <div className="mt-1" data-id="element-14609">
                <input type="email" name="email" id="email" value={formData.email} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-14610" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-14611">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-14612">
                Phone
              </label>
              <div className="mt-1" data-id="element-14613">
                <input type="tel" name="phone" id="phone" value={formData.phone} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-14614" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-14615">
              <label htmlFor="role" className="block text-sm font-medium text-gray-700" data-id="element-14616">
                Role/Type
              </label>
              <div className="mt-1" data-id="element-14617">
                <select id="role" name="role" value={formData.role} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-14618">
                  <option value="Admin" data-id="element-14619">Admin</option>
                  <option value="Finance" data-id="element-14620">Finance</option>
                  <option value="Technical" data-id="element-14621">Technical</option>
                  <option value="Operations" data-id="element-14622">Operations</option>
                  <option value="Sales" data-id="element-14623">Sales</option>
                  <option value="Support" data-id="element-14624">Support</option>
                  <option value="Other" data-id="element-14625">Other</option>
                </select>
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-14626">
              <div className="flex items-center h-full" data-id="element-14627">
                <input id="isPrimary" name="isPrimary" type="checkbox" checked={formData.isPrimary} onChange={handleChange} className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-14628" />
                <label htmlFor="isPrimary" className="ml-2 block text-sm text-gray-700" data-id="element-14629">
                  Is Primary Contact
                </label>
              </div>
            </div>
          </div>
          <div className="flex justify-end space-x-3" data-id="element-14630">
            <button type="button" onClick={onCancel} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14631">
              Cancel
            </button>
            <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14632">
              <SaveIcon className="h-4 w-4 mr-2" data-id="element-14633" />
              Save Contact
            </button>
          </div>
        </form>
      </div>
    </div>;
}